import { put, call } from 'redux-saga/effects';
import { aflt_departmentList, aflt_departmentAdd, aflt_departmentUpdate, aflt_departmentDelete } from '../../../services/settings/affiliates/aflt_departmentsService';

import * as types from '../../../actions';

export function* aflt_departmentListSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_departmentList, payload);
      yield put({ type: types.DEPARTMENT_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.DEPARTMENT_LIST_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
} 

export function* aflt_departmentAddSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_departmentAdd, payload);
      yield put({ type: types.DEPARTMENT_ADD_AFFILIATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DEPARTMENT_ADD_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* aflt_departmentUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_departmentUpdate, payload);
    yield put({ type: types.DEPARTMENT_UPDATE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DEPARTMENT_UPDATE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_departmentDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_departmentDelete, payload);
    yield put({ type: types.DEPARTMENT_DELETE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DEPARTMENT_DELETE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


